import { createSlice } from '@reduxjs/toolkit'
import { FormConfiguration } from '../configuration'

const initialState = {
    nome: '',
    cognome: '',
    professione: '',
    email: '',
    messagio: '',
    firstCheckBox: true,
    secondCheckBox: false,
    paese: FormConfiguration.paesi[0],
    citta: FormConfiguration.citta[0],
    cap: FormConfiguration.cap[0]
}

const formSlice = createSlice({
    name: 'form',
    initialState,
    reducers: {
        handleChange(state, action) {
            state[action.payload.name] = action.payload.value
        }
    }
})

export const { handleChange } = formSlice.actions
export default formSlice.reducer